import gsap from 'gsap'

export const initCursor = () => {
	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
	const prefersHighContrast = window.matchMedia('(prefers-contrast: high)').matches

	if (prefersReducedMotion || prefersHighContrast) {
		// return
	}
	
	gsap.set('.cursor', { xPercent: -5, yPercent: -5 })
	const cursor = document.querySelector('.cursor')
	const position = { x: window.innerWidth / 2, y: window.innerHeight / 2 }
	const mouse = { x: position.x, y: position.y }

	window.addEventListener('mousemove', (e) => {
		mouse.x = e.x
		mouse.y = e.y
		gsap.to(cursor, { duration: 0.35, x: mouse.x, y: mouse.y })
	})
}

export const initCursorEvents = () => {
	const cursor = document.querySelector('.cursor')
	const items = document.querySelectorAll('[data-cursor]')

	items.forEach(item => {
		item.addEventListener('mouseenter', () => {
			cursor.dataset.icon = item.dataset.cursor
			cursor.classList.add('visible')
		})
		item.addEventListener('mouseleave', () => {
			cursor.dataset.icon = ''
			cursor.classList.remove('visible')
		})
		item.addEventListener('click', () => {
			setTimeout(() => {
				cursor.dataset.icon = item.dataset.cursor
			}, 100);
		})
	})
	document.addEventListener('mousedown', () => {
		if (cursor.classList.contains('visible')) {
			cursor.classList.add('shrink')
		}
	})
	document.addEventListener('mouseup', () => {
		cursor.classList.remove('shrink')
	})
}

export const removeCursorState = () => {
	const cursor = document.querySelector('.cursor')
	cursor.classList.remove('visible')
	cursor.classList.remove('shrink')
	cursor.dataset.icon = ''
}

export default () => { }